import { Box, Typography } from "@mui/material";
import { Art } from "../../Models/Art";
import { StyledGalleryArtMenu } from "./GalleryArtMenu.styled";
import { useState } from "react";
import { SERVERURL } from "../../Globals/Constants";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react/dist/ssr";

type GalleryArtMenuProps = {
  artItem: Art;
};

export const GalleryArtMenu = ({ artItem }: GalleryArtMenuProps) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);

  const handleClick = (direction: number) => {
    setSelectedImageIndex(selectedImageIndex + direction)
  };

  return (
    <StyledGalleryArtMenu>
      <Typography variant="h2">{artItem.title}</Typography>
      <Box className="content">
        <CaretLeftIcon
          size={64}
          weight="bold"
          className={`caretLeft ${selectedImageIndex === 0 && "selected"}`}
          onClick={() => selectedImageIndex !== 0 && handleClick(-1)}
        />
        <Box className="imageWrapper">
          <img
            src={`${SERVERURL}${artItem.files[selectedImageIndex].filePath}`} alt={artItem.title}
          />
        </Box>
        <CaretRightIcon
          size={64}
          weight="bold"
          className={`caretRight ${selectedImageIndex === artItem.files.length - 1 && "selected"}`}
          onClick={() =>  selectedImageIndex !== artItem.files.length - 1 && handleClick(1)}
        />
      </Box>

      <Box className="imagePreviewWrapper">
        {artItem.files.map(({ id }, index) => (
          <Box
            className={`imagePreview ${
              selectedImageIndex === index && "selected"
            }`}
            key={id}
            onClick={() => setSelectedImageIndex(index)}
          />
        ))}
      </Box>
    </StyledGalleryArtMenu>
  );
};
